import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["free-space-info-category"];
  static targets = ["newInfoCategoryTemplate", "newInfoCategoryAppendButton"];
  static values = { maxInfoCategories: Number };

  freeSpaceInfoCategoryOutletDisconnected() {
    this.updateNewInfoCategoryAppendButtonVisibility();
  }

  appendNewInfoCategory() {
    const template = this.newInfoCategoryTemplateTarget.content.cloneNode(true);
    const index = this.numberOfInfoCategories();

    const titleInputEl = template.querySelector(
      ".js-info-category-title-input"
    );
    titleInputEl.name = `free_space_setting_form[free_space_info_categories_attributes][${index}][title]`;

    const editorContainerEl = template.querySelector(
      ".js-info-category-content-editor-container"
    );
    const editorEl = document.createElement("trix-editor");
    editorEl.classList.add("trix-content");
    editorContainerEl.appendChild(editorEl);

    template.querySelector(
      ".js-info-category-attachment-input"
    ).name = `free_space_setting_form[free_space_info_categories_attributes][${index}][attachment]`;

    template.querySelector(
      ".js-info-category-attachment-link-text-input"
    ).name = `free_space_setting_form[free_space_info_categories_attributes][${index}][attachment_link_text]`;

    template.querySelector(
      ".js-info-category-url-input"
    ).name = `free_space_setting_form[free_space_info_categories_attributes][${index}][url]`;

    template.querySelector(
      ".js-info-category-url-link-text-input"
    ).name = `free_space_setting_form[free_space_info_categories_attributes][${index}][url_link_text]`;

    this.newInfoCategoryTemplateTarget.before(template);

    const contentInputEl = document.getElementById(
      editorEl.getAttribute("input")
    );
    contentInputEl.name = `free_space_setting_form[free_space_info_categories_attributes][${index}][content]`;

    titleInputEl.focus();
    window.applyThemeColor(window.getThemeColorCodeFromMeta());
    this.updateNewInfoCategoryAppendButtonVisibility();
  }

  numberOfInfoCategories() {
    return this.freeSpaceInfoCategoryOutlets.length;
  }

  updateNewInfoCategoryAppendButtonVisibility() {
    if (this.numberOfInfoCategories() >= this.maxInfoCategoriesValue) {
      this.newInfoCategoryAppendButtonTarget.classList.add("is-hidden");
    } else {
      this.newInfoCategoryAppendButtonTarget.classList.remove("is-hidden");
    }
  }
}
